export type BillingsOrderForwardTaxiTaxiRecalculateParamsNode = {
  uuid: string;
  nodeUuid: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate: Date | null;
  checkoutEventUuid: string | null;
  plannedDate: Date | null;
  orderUuid: string | null;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export enum BillingsOrderForwardTaxiTaxiRecalculateParamsContributionType {
  BONUS_FAVORABLE_DISTANCE = "BONUS_FAVORABLE_DISTANCE",
  BONUS_OTHER = "BONUS_OTHER",
  PENALTY_WRONG_ROUTE = "PENALTY_WRONG_ROUTE",
  PENALTY_BEING_LATE = "PENALTY_BEING_LATE",
  PENALTY_INCOMPATIBLE_CAR = "PENALTY_INCOMPATIBLE_CAR",
  PENALTY_OTHER = "PENALTY_OTHER",
}

export type BillingsOrderForwardTaxiTaxiRecalculateParamsContributionBonusFavorableDistance =
  {
    type: BillingsOrderForwardTaxiTaxiRecalculateParamsContributionType.BONUS_FAVORABLE_DISTANCE;
    comment: string | null;
    distance: number;
    rate: number;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateParamsContributionBonusOther =
  {
    type: BillingsOrderForwardTaxiTaxiRecalculateParamsContributionType.BONUS_OTHER;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateParamsContributionPenaltyWrongRoute =
  {
    type: BillingsOrderForwardTaxiTaxiRecalculateParamsContributionType.PENALTY_WRONG_ROUTE;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateParamsContributionPenaltyBeingLate =
  {
    type: BillingsOrderForwardTaxiTaxiRecalculateParamsContributionType.PENALTY_BEING_LATE;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateParamsContributionPenaltyIncompatibleCar =
  {
    type: BillingsOrderForwardTaxiTaxiRecalculateParamsContributionType.PENALTY_INCOMPATIBLE_CAR;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateParamsContributionPenaltyOther =
  {
    type: BillingsOrderForwardTaxiTaxiRecalculateParamsContributionType.PENALTY_OTHER;
    comment: string | null;
    amount: number;
  };

export type BillingsOrderForwardTaxiTaxiRecalculateParamsContributionBonus =
  | BillingsOrderForwardTaxiTaxiRecalculateParamsContributionBonusFavorableDistance
  | BillingsOrderForwardTaxiTaxiRecalculateParamsContributionBonusOther;

export type BillingsOrderForwardTaxiTaxiRecalculateParamsContributionPenalty =
  | BillingsOrderForwardTaxiTaxiRecalculateParamsContributionPenaltyWrongRoute
  | BillingsOrderForwardTaxiTaxiRecalculateParamsContributionPenaltyBeingLate
  | BillingsOrderForwardTaxiTaxiRecalculateParamsContributionPenaltyIncompatibleCar
  | BillingsOrderForwardTaxiTaxiRecalculateParamsContributionPenaltyOther;

export type BillingsOrderForwardTaxiTaxiRecalculateParamsContribution =
  | BillingsOrderForwardTaxiTaxiRecalculateParamsContributionBonus
  | BillingsOrderForwardTaxiTaxiRecalculateParamsContributionPenalty;

type BillingsOrderForwardTaxiTaxiRecalculateParams = {
  orderForwardingUuid: string;
  billingNodes: BillingsOrderForwardTaxiTaxiRecalculateParamsNode[];
  billingContributions: BillingsOrderForwardTaxiTaxiRecalculateParamsContribution[];
};

export default BillingsOrderForwardTaxiTaxiRecalculateParams;
